module.exports = __webpack_public_path__ + "img/category-annual-tickets.e41f017a.jpg";